import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { SUBURBS, suburbPath } from "@/data/suburbs";

export default function Footer() {
  return (
    <footer className="bg-tpeco-ink text-white border-t-4 border-tpeco-blue grain-overlay" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src="/logo.webp" alt="The Plumbing & Electrical Co badge" className="h-14 w-14 object-contain" />
            <span className="font-display text-2xl uppercase leading-tight">HOT WATER SYSTEMS<br /><span className="text-tpeco-blue">PERTH</span></span>
          </div>
          <p className="mt-4 text-sm font-semibold text-neutral-400 max-w-xs">
            By The Plumbing &amp; Electrical Co. — Perth's plumbing, electrical and gas crew with upfront pricing
            and Australia's first online tradie booking portal.
          </p>
          <a href="https://www.tpeco.com.au/" target="_blank" rel="noopener noreferrer"
            className="mt-3 inline-block text-tpeco-pink font-bold underline underline-offset-4" data-testid="footer-main-site-link">
            tpeco.com.au →
          </a>
        </div>
        <div>
          <h3 className="font-display uppercase text-2xl text-tpeco-blue">GET US</h3>
          <ul className="mt-4 space-y-3 font-semibold text-sm">
            <li><a href="tel:0475776555" className="flex items-center gap-2 hover:text-tpeco-pink transition-colors" data-testid="footer-phone-mobile"><Phone className="w-4 h-4" /> 0475 776 555 (call or text)</a></li>
            <li><a href="tel:+61894773848" className="flex items-center gap-2 hover:text-tpeco-pink transition-colors" data-testid="footer-phone-landline"><Phone className="w-4 h-4" /> (08) 9477 3848</a></li>
            <li><a href="mailto:team@tpeco.com.au" className="flex items-center gap-2 hover:text-tpeco-pink transition-colors" data-testid="footer-email"><Mail className="w-4 h-4" /> team@tpeco.com.au</a></li>
            <li className="flex items-start gap-2 text-neutral-400"><MapPin className="w-4 h-4 mt-0.5 shrink-0" /> Servicing all Perth suburbs — Rockingham to Joondalup and beyond.</li>
          </ul>
        </div>
        <div>
          <h3 className="font-display uppercase text-2xl text-tpeco-blue">THE LEGAL BITS</h3>
          <ul className="mt-4 space-y-2 text-xs font-bold uppercase tracking-widest text-neutral-400" data-testid="footer-licences">
            <li>Plumbing Licence: PL 8061</li>
            <li>Electrical Licence: EC 17738</li>
            <li>Gas Fitting Licence: GL 013140</li>
            <li>Backflow Licence: BFL 2246</li>
            <li>ABN: 16 623 157 067</li>
          </ul>
          <p className="mt-4 text-xs text-neutral-500 font-semibold">
            All prices include GST and are for like-for-like swap-outs. Final price confirmed before work starts.
            Finance available via Afterpay, Zip &amp; Brighte.
          </p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pb-10" data-testid="footer-help">
        <h3 className="font-display uppercase text-2xl text-tpeco-blue">HOT WATER HELP</h3>
        <div className="mt-4 flex flex-wrap gap-x-6 gap-y-2 text-xs font-semibold text-neutral-400">
          <Link to="/noisy-hot-water-system" className="hover:text-tpeco-pink transition-colors" data-testid="footer-help-noisy">Noisy hot water system</Link>
          <Link to="/no-hot-water-perth" className="hover:text-tpeco-pink transition-colors" data-testid="footer-help-nohotwater">No hot water?</Link>
          <Link to="/upgrade-hot-water-system" className="hover:text-tpeco-pink transition-colors" data-testid="footer-help-upgrade">Upgrades &amp; downgrades</Link>
          <Link to="/change-hot-water-system-style" className="hover:text-tpeco-pink transition-colors" data-testid="footer-help-style">Change system style</Link>
          <Link to="/hot-water-too-hot" className="hover:text-tpeco-pink transition-colors" data-testid="footer-help-toohot">Water too hot?</Link>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pb-10" data-testid="footer-suburbs">
        <h3 className="font-display uppercase text-2xl text-tpeco-blue">SUBURBS WE SERVICE</h3>
        <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-2 text-xs font-semibold text-neutral-400">
          {SUBURBS.map((s) => (
            <Link key={s.slug} to={suburbPath(s)} className="hover:text-tpeco-pink transition-colors" data-testid={`footer-suburb-${s.slug}`}>
              Hot Water Systems {s.name}
            </Link>
          ))}
        </div>
      </div>
      <div className="border-t border-neutral-800 py-5 pb-24 md:pb-5 text-center text-xs font-bold uppercase tracking-widest text-neutral-500" data-testid="footer-copyright">
        © {new Date().getFullYear()} The Plumbing &amp; Electrical Co. · Hot Water Systems Perth · From brrr to ahhh.
      </div>
    </footer>
  );
}
